import React, { memo, useContext } from 'react';
import i18n from '@i18n';
import { formatMoney } from '@/common/client';
import { fireGAEvent } from '@/analytics';
import PopupNg from '@/ui/PopupNg';
import clsx from 'clsx';
import SpeedingEuroIcon from '@/icons/SpeedingEuroIcon';
import LockIcon from '@/icons/LockIcon';
import { Button } from 'nike-ui/src/components/button/Button';
import { fromJS } from 'immutable';
import { logCashinDialogOpen } from 'nike-ui/src/common/logging/cashin/log';
import { useIsChannelStatusDelayed } from 'nike-ui/src/components/ticketus/cashin/useIsChannelStatusDelayed';
import CashinPositionContext from 'nike-ui/src/common/CashinPositionContext';

export const CashinButton = memo(function CashinButton({ cashinOffer, detailInfo = true, disabled = false }) {
    const isChannelStatusDelayed = useIsChannelStatusDelayed(cashinOffer);
    const iconHeight = detailInfo ? 14 : 16;
    const { cashinPosition } = useContext(CashinPositionContext);

    function handleClick() {
        fireGAEvent('Odkup tiketu', 'Predaj podaneho tiketu');
        const ticketId = cashinOffer.ticketId;
        PopupNg.dispatcher.open('ticketus/cashin-dialog', fromJS({ ticketId, cashinPosition }), 2);
        logCashinDialogOpen({ ticketId, offer: fromJS(cashinOffer) });
    }

    return isChannelStatusDelayed ? null : (
        <Button
            disabled={disabled}
            data-atid="cashin-button"
            className={clsx('green btn-cashin')}
            primary
            onClick={handleClick}
        >
            <div>
                <div className={'btn-row'}>
                    {disabled ? (
                        <LockIcon width={14} height={iconHeight} className="icon" fill="#fff" />
                    ) : (
                        <div
                            className={detailInfo && cashinOffer.automaticTransactionLimit ? 'item-badge' : ''}
                            data-badge={'A'}
                        >
                            <SpeedingEuroIcon height={iconHeight} className="icon" fill="#fff" />
                            {i18n('commons.term.odkup-mozny-alt')}&nbsp;
                            {formatMoney(cashinOffer.amount, 'EUR')}
                        </div>
                    )}
                </div>
            </div>
        </Button>
    );
});
